import { createReducer, on } from '@ngrx/store';
import * as UpdateAccountPasswordActions from '../actions/update-account-password.actions';

export const updateAccountPasswordFeatureKey = 'updateAccountPassword';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(UpdateAccountPasswordActions.updateAccountPassword, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(UpdateAccountPasswordActions.updateAccountPasswordSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(UpdateAccountPasswordActions.updateAccountPasswordFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(UpdateAccountPasswordActions.clearUpdateAccountPasswordState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

